import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import Config from './Config.js';

export default class Classe extends Config{

	constructor(currentEnv, roomName, roomConfig, whereToAddObjects, data) {
		super(currentEnv, roomName, roomConfig, whereToAddObjects, data);

		if (data) {
			this.data = {entreTable: parseFloat(data.et), entreRange: parseFloat(data.er), praticable: (data.p == "true"), isEcranMural: (data.em == "true")};
		}
		else {
			this.data = {entreTable: 2, entreRange: 1.6, praticable: false, isEcranMural: false};
		}

		this.grandEcranObject = this.currentEnv.getObjectByName("Screen_" + this.roomName + "_C");
		if (!(this.grandEcranObject)) {
			this.grandEcranObject = this.currentEnv.getObjectByName("Screen_" + this.roomName);
		}
		this.plafonnierObject = this.currentEnv.getObjectByName("Plafonnier_" + this.roomName);
		this.praticableObject = this.currentEnv.getObjectByName("Praticable_" + this.roomName);
		this.sortieSecoursObject = this.currentEnv.getObjectByName("SortieSecours_" + this.roomName);

		this.roomWithDifferentPlacement = ["1_2", "2_3", "1_2_3", "5", "6", "7", "11"];

	}

	Show() {
		if (!this.refTable) {
			this.CreateTable();
		}
		else if (!this.refPraticable) {
			this.CreatePraticable();
		}
		else if(!this.refGrandEcran) {
			this.CreateGrandEcran();
		}
		else if(!this.refPlafonnier) {
			this.CreatePlafonnier();
		}
		else if(!this.refSortieSecours) {
			this.CreateSortieSecours();
		}
		else {
			var currentTable = [];
			var currentGrandEcran = [];
			var currentPraticables = [];
			var currentPlafonnier = [];
			var currentSortieSecours = [];

			for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
				if (this.whereToAddObjects.children[i].name == "Praticable") {
					currentPraticables.push(this.whereToAddObjects.children[i]);
					if (this.data.praticable) {
						this.whereToAddObjects.children[i].visible = true;
					}
					else {
						this.whereToAddObjects.children[i].visible = false;
					}
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentPraticables.length;
				}

				if (this.whereToAddObjects.children[i].name == "Classe") {
					currentTable.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = true;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentTable.length;
				}

				if (this.whereToAddObjects.children[i].name == "Grand_Ecran") {
					currentGrandEcran.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentGrandEcran.length;
				}

				if (this.whereToAddObjects.children[i].name == "Ecran_Plafonnier") {
					currentPlafonnier.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
				}

				if (this.whereToAddObjects.children[i].name == "Sortie_Secours") {
					currentSortieSecours.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentSortieSecours.length;
				}
			}

			var distancePos = this.distanceObject.getObjectByName("Distance_" + this.roomConfig);
			if (distancePos) {
				this.CreateDistances(distancePos);
			}

			if (this.data.praticable) {
				var praticablePos = this.praticableObject.getObjectByName(this.roomConfig);
				if (praticablePos) {
					for (var i = 0; i < praticablePos.children.length; i++) {
						if (i < currentPraticables.length)
							this.objectGenerator.ApplyTransform(currentPraticables[i], {refObject: praticablePos.children[i]});
						else {
							currentPraticables.push(this.objectGenerator.CloneElement(this.refPraticable, this.whereToAddObjects, {refObject: praticablePos.children[i]}));
							currentPraticables[currentPraticables.length - 1].simsData.id = currentPraticables.length;
						}
					}
				}
				else {
					for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
						if (this.whereToAddObjects.children[i].name == "Praticable") {
							this.whereToAddObjects.children[i].visible = false;
						}
					}
				}
			}

			var plafonnierPos = this.plafonnierObject.getObjectByName("Plafonnier_" + this.roomConfig);
			if (plafonnierPos) {
				if (currentPlafonnier.length >= 1) {
					this.objectGenerator.ApplyTransform(currentPlafonnier[0], {refObject: plafonnierPos});
					if (this.data.isEcranMural) {
						currentPlafonnier[0].visible = true;
					}
				}
				else {
					this.objectGenerator.CloneElement(this.refPlafonnier, this.whereToAddObjects, {refObject: plafonnierPos});
				}
			}

			var sortieSecoursPos = this.sortieSecoursObject.getObjectByName("SortieSecours_" + this.roomConfig);
			if (sortieSecoursPos) {
				if (sortieSecoursPos.children.length) {
					for (var i = 0; i < sortieSecoursPos.children.length; i++) {
						if (i < currentSortieSecours.length) {
							this.objectGenerator.ApplyTransform(currentSortieSecours[i], {refObject: sortieSecoursPos.children[i]});
							currentSortieSecours[i].visible = true;
						}
						else {
							currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos.children[i]}));
							currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
						}
					}
				}
				else {
					if (currentSortieSecours.length >= 1) {
						this.objectGenerator.ApplyTransform(currentSortieSecours[0], {refObject: sortieSecoursPos});
						currentSortieSecours[0].visible = true;
					}
					else {
						currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos}));
						currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
					}
				}
			}

			var delim = this.delimZones.getObjectByName("DRoom_" + this.roomConfig);
			var zoneDelimData = this.SetupDelimData(delim);

			var tableRotation = 0;
			if (zoneDelimData.length) {
				zoneDelimData = zoneDelimData[0];
			}

			zoneDelimData.entreRangeMin = zoneDelimData.minX;
			zoneDelimData.entreRangeMax = zoneDelimData.maxX;
			zoneDelimData.entreTableMin = zoneDelimData.minZ;
			zoneDelimData.entreTableMax = zoneDelimData.maxZ;

			switch(this.roomConfig) {
				case "1":
				case "2":
				case "3":
					zoneDelimData.entreRangeMin = zoneDelimData.minZ + 3.5;
					zoneDelimData.entreRangeMax = zoneDelimData.maxZ - 1;
					zoneDelimData.entreTableMin = zoneDelimData.minX + 0.5;
					zoneDelimData.entreTableMax = zoneDelimData.maxX - 0.5;
					tableRotation = Math.PI;
					break;
				case "1_2":
				case "1_2_3":
					zoneDelimData.entreRangeMin += 1;
					zoneDelimData.entreRangeMax -= 4;
					zoneDelimData.entreTableMin +=0.5;
					zoneDelimData.entreTableMax -=1;
					tableRotation = Math.PI/2;
					break;
				case "2_3":
					zoneDelimData.entreRangeMin += 3;
					zoneDelimData.entreRangeMax -= 1;
					zoneDelimData.entreTableMin +=0.5;
					zoneDelimData.entreTableMax -=1;
					tableRotation = -Math.PI/2;
					break;
				case "4":
					zoneDelimData.entreRangeMin = zoneDelimData.minZ + 1.5;
					zoneDelimData.entreRangeMax = zoneDelimData.maxZ - 2;
					zoneDelimData.entreTableMin = zoneDelimData.minX + 0.5;
					zoneDelimData.entreTableMax = zoneDelimData.maxX - 0.5;
					break;
				case "5":
				case "6":
				case "7":
					tableRotation = Math.PI/2;
					zoneDelimData.entreRangeMin += 1;
					zoneDelimData.entreRangeMax -= 2;
					zoneDelimData.entreTableMin += 1;
					zoneDelimData.entreTableMax -= 0.5;
					break;
				case "11":
					tableRotation = -Math.PI/2;
					zoneDelimData.entreRangeMin += 2;
					zoneDelimData.entreRangeMax -= 1;
					zoneDelimData.entreTableMin += 0.5;
					zoneDelimData.entreTableMax -= 0.5;
					break;
				case "8":
				case "9":
				case "10":
					zoneDelimData.entreRangeMin = zoneDelimData.minZ + 2.5;
					zoneDelimData.entreRangeMax = zoneDelimData.maxZ - 0.5;
					zoneDelimData.entreTableMin = zoneDelimData.minX + 0.5;
					zoneDelimData.entreTableMax = zoneDelimData.maxX - 1;
					tableRotation = Math.PI;
					break;
			}

			var nbEcrans = 0;
			var grandEcranPos = this.grandEcranObject.getObjectByName("Screen_" + this.roomConfig + "_C");
			if (!(grandEcranPos)) {
				grandEcranPos = this.grandEcranObject.getObjectByName("Screen_" + this.roomConfig);
			}
			if (grandEcranPos) {
				if (grandEcranPos.children.length) {
					if (this.roomConfig == "1" || this.roomConfig == "2" || this.roomConfig == "3") {
						for (var i = 0; i < grandEcranPos.children.length; i++) {
							if ((this.data.praticable && grandEcranPos.children[i].name.includes("Prat")) ||
								(!this.data.praticable && !grandEcranPos.children[i].name.includes("Prat"))) {
								if (nbEcrans < currentGrandEcran.length) {
									this.objectGenerator.ApplyTransform(currentGrandEcran[nbEcrans], {refObject: grandEcranPos.children[i]});
									currentGrandEcran[nbEcrans].visible = true;
									nbEcrans++;
								}
								else {
									currentGrandEcran.push(this.objectGenerator.CloneElement(this.refGrandEcran, this.whereToAddObjects, {refObject: grandEcranPos.children[i]}));
									currentGrandEcran[currentGrandEcran.length - 1].simsData.id = currentGrandEcran.length;
									nbEcrans++;
								}
							}
						}
					}
					else {
						for (var i = 0; i < grandEcranPos.children.length; i++) {
							if (i < currentGrandEcran.length) {
								this.objectGenerator.ApplyTransform(currentGrandEcran[i], {refObject: grandEcranPos.children[i]});
								currentGrandEcran[i].visible = true;
							}
							else {
								currentGrandEcran.push(this.objectGenerator.CloneElement(this.refGrandEcran, this.whereToAddObjects, {refObject: grandEcranPos.children[i]}));
								currentGrandEcran[currentGrandEcran.length - 1].simsData.id = currentGrandEcran.length;
							}
						}
					}
				}
				else {
					if (currentGrandEcran.length >= 1) {
						this.objectGenerator.ApplyTransform(currentGrandEcran[0], {refObject: grandEcranPos});
						currentGrandEcran[0].visible = true;
					}
					else {
						currentGrandEcran.push(this.objectGenerator.CloneElement(this.refGrandEcran, this.whereToAddObjects, {refObject: grandEcranPos}));
						currentGrandEcran[currentGrandEcran.length - 1].simsData.id = currentGrandEcran.length;
					}
				}
			}

			var newPos = {};
			var tableCount = 0;

			var tableLenght = 1.4;
			var realEntreTable = this.data.entreTable - tableLenght;
			var distanceBetweenZone = zoneDelimData.entreTableMax - zoneDelimData.entreTableMin;

			var nbTableParRange = Math.floor((distanceBetweenZone - tableLenght) / this.data.entreTable) + 1;

			var tableDistance = (nbTableParRange * tableLenght) + ((nbTableParRange - 1) * realEntreTable);


			for (var i = zoneDelimData.entreRangeMin; i < zoneDelimData.entreRangeMax; i += this.data.entreRange) {
				for (var j = zoneDelimData.entreTableMin + (tableLenght / 2) + ((distanceBetweenZone - tableDistance) / 2); j < zoneDelimData.entreTableMax - (tableLenght / 2); j += this.data.entreTable) {

					newPos.posX = i;
					newPos.posZ = j;
					if (tableCount < currentTable.length) {
						currentTable[tableCount].rotation.set(0, 0, 0);
						if (this.roomWithDifferentPlacement.includes(this.roomConfig)) {
							this.objectGenerator.ApplyTransform(currentTable[tableCount], {posX: i, posZ: j, rotY: tableRotation});
						}
						else {
							this.objectGenerator.ApplyTransform(currentTable[tableCount], {posX: j, posZ: i, rotY: tableRotation});
						}
					}
					else {
						if (this.roomWithDifferentPlacement.includes(this.roomConfig)) {
							currentTable.push(this.objectGenerator.CloneElement(this.refTable, this.whereToAddObjects, {posX: i, posZ: j, rotY: tableRotation}));
						}
						else {
							currentTable.push(this.objectGenerator.CloneElement(this.refTable, this.whereToAddObjects, {posX: j, posZ: i, rotY: tableRotation}));
						}
						currentTable[currentTable.length - 1].simsData.id = currentTable.length;
						/*
						var newTable = this.refTable.clone();
						this.whereToAddObjects.add(newTable);
						newTable.rotation.set(0, 0, 0);
						if (this.roomWithDifferentPlacement.includes(this.roomConfig)) {
							this.objectGenerator.ApplyTransform(newTable, {posX: i, posZ: j, rotY: tableRotation});
						}
						else {
							this.objectGenerator.ApplyTransform(newTable, {posX: j, posZ: i, rotY: tableRotation});
						}*/
					}

					tableCount++;
				}
			}

			if (this.simsDataFunction) {
				this.simsDataFunction();
			}
			if (currentTable.length > tableCount) {
				this.HideObjectAdded(currentTable, tableCount);
			}

			this.data.type = "Classe";
			this.data.tableCount = tableCount;
		}
	}

	Modify(value) {
		if (value.type == "entreTable") {
			this.data.entreTable = parseFloat(value.value);
		}
		else if (value.type == "entreRange") {
			this.data.entreRange = parseFloat(value.value);
		}
		else if (value.type == "praticable") {
			this.data.praticable = value.value;
		}
		else if (value.type == "isEcranMural") {
			this.data.isEcranMural = value.value;
		}
		this.Show();
	}

	ChangeRoomConfig(roomName, roomConfig) {
		this.roomConfig = roomConfig;
		this.roomName = roomName;
	}


	CreateTable() {
		this.refTable = this.whereToAddObjects.getObjectByName("Classe");
		if (this.refTable) {
			this.refTable.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateTable();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("Classe", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreatePraticable() {
		this.refPraticable = this.whereToAddObjects.getObjectByName("Praticable");
		if (this.refPraticable) {
			this.refPraticable.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreatePraticable();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Praticable", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreateGrandEcran() {
		this.refGrandEcran = this.whereToAddObjects.getObjectByName("Grand_Ecran");
		if (this.refGrandEcran) {
			this.refGrandEcran.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateGrandEcran();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Grand_Ecran", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreatePlafonnier() {
		this.refPlafonnier = this.whereToAddObjects.getObjectByName("Ecran_Plafonnier");
		if (this.refPlafonnier) {
			this.refPlafonnier.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreatePlafonnier();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("Ecran_Plafonnier", this.whereToAddObjects, newPos);
		}
	}

	CreateSortieSecours() {
		this.refSortieSecours = this.whereToAddObjects.getObjectByName("Sortie_Secours");
		if (this.refSortieSecours){
			this.refSortieSecours.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateSortieSecours();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Sortie_Secours", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	ResetBaseConfig() {
		this.data = {entreTable: 2, entreRange: 1.6, praticable: false};
	}
}